// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WNJx","col":"styles_col__2v0fI"};